import { SelectionItemInterface } from '@cube3/state/src/redux/ducks/selections';

import fileImage from '@cube3/ui/src/assets/images/Library/file.svg?url';
import folderImage from '@cube3/ui/src/assets/images/Library/folder.svg?url';

const srcs = {
    folder: folderImage,
    asset: fileImage
};

/**
 * 
 * @param selections 
 * @returns selection array containing only folder or asset resources and an array with images to show during drag 
 */
export const filterDragableSelections = (selections: SelectionItemInterface[]) => {
    if (!selections || selections.length === 0) return undefined;
    const filtered =
        (selections.filter((s) => ['asset', 'folder'].includes(s.type)) || []) as Array<SelectionItemInterface & { type: 'asset' | 'folder' }>;
    const data =
        filtered.map((i) => ({
            id: i.id,
            type: i.type,
            parent: i['relationships']['parent']?.id
        })) || [];
    const images =
        filtered.map((i) => i['attributes']?.display_image || srcs[i.type]) || [];
    return { data, images };
};